import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function EyeIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="EyeIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <rect id="Rectángulo_2487" width="24" height="24" fill="none" />
            <g id="Grupo_365" transform="translate(0.001)">
                <path
                    id="Trazado_5981"
                    d="M2.062,12.348a1,1,0,0,1,0-.7,10.75,10.75,0,0,1,19.876,0,1,1,0,0,1,0,.7,10.75,10.75,0,0,1-19.876,0"
                    fill="none"
                    stroke="#a7a7a7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
                <circle
                    id="Elipse_3"
                    cx="3"
                    cy="3"
                    r="3"
                    transform="translate(9 9)"
                    fill="none"
                    stroke="#a7a7a7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                />
            </g>
        </SvgIcon>
    );
}
